import { PROJECT_AUDIO_TYPES } from 'consts/audio'
import { IAudioItem, TAudioType } from 'types/audio'

interface IParams {
  assetId: string
  duration: number
  path: string
  title: string
  type: TAudioType
  projectStart: number
  lineIndex: number
}

export const generateAndGetAudioDefaultDataForProject = (data: IParams) => {
  const { assetId, duration, path, title, type, projectStart, lineIndex } = data

  return {
    id: crypto.randomUUID(),
    volume: 100,
    mediaStart: 0,
    lineIndex,
    assetId,
    duration,
    mediaDuration: duration,
    mediaPath: path,
    title,
    type,
    projectStart
  }
}

const isUserUploadedAudio = (audio: IAudioItem) =>
  audio.mediaPath.includes('uploads')

export const isAudioFromGenres = (audio: IAudioItem) =>
  audio.type === 'SOUND' && !isUserUploadedAudio(audio)
export const isAudioItem = (type: string | null): boolean => {
  const audioTypes = Object.values(PROJECT_AUDIO_TYPES) as string[]
  return type ? audioTypes.includes(type) : false
}

export const isUploadingAudio = (audio: IAudioItem) =>
  audio.mediaPath.includes('blob') && audio.type === PROJECT_AUDIO_TYPES.SOUND
